import { EncodeObject, GeneratedType } from '@cosmjs/proto-signing';
import { MsgCreatePlan, MsgBuy, MsgSell, MsgClaim, MsgBuyExactSpend } from './ts-client/tx';

export const iroTypes: ReadonlyArray<[ string, GeneratedType ]> = [
  [ '/dymensionxyz.dymension.iro.MsgCreatePlan', MsgCreatePlan ],
  [ '/dymensionxyz.dymension.iro.MsgBuy', MsgBuy ],
  [ '/dymensionxyz.dymension.iro.MsgSell', MsgSell ],
  [ '/dymensionxyz.dymension.iro.MsgClaim', MsgClaim ],
  [ '/dymensionxyz.dymension.iro.MsgBuyExactSpend', MsgBuyExactSpend ],
];

export interface MsgCreatePlanEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.iro.MsgCreatePlan';
  readonly value: Partial<MsgCreatePlan>;
}

export interface MsgBuyEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.iro.MsgBuy';
  readonly value: Partial<MsgBuy>;
}

export interface MsgBuyExactSpendEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.iro.MsgBuyExactSpend';
  readonly value: Partial<MsgBuyExactSpend>;
}


export interface MsgSellEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.iro.MsgSell';
  readonly value: Partial<MsgSell>;
}

export interface MsgClaimEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.iro.MsgClaim';
  readonly value: Partial<MsgClaim>;
}

export function isMsgCreatePlanEncodeObject(object: EncodeObject): object is MsgCreatePlanEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.iro.MsgCreatePlan';
}

export function isMsgBuyEncodeObject(object: EncodeObject): object is MsgBuyEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.iro.MsgBuy';
}

export function isMsgBuyExactSpendEncodeObject(object: EncodeObject): object is MsgBuyExactSpendEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.iro.MsgBuyExactSpend';
}

export function isMsgSellEncodeObject(object: EncodeObject): object is MsgSellEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.iro.MsgSell';
}

export function isMsgClaimEncodeObject(object: EncodeObject): object is MsgClaimEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.iro.MsgClaim';
}


